import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { Card, Col, Form, Row } from "react-bootstrap";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import {
      FormButton,
      FormImage,
      FormInput,
      FormSelect,
      FormStatusSelect,
} from "../../components/form";
import { privateApi } from "../../api";

const designs = [
      {
            title: "Left Banner Design",
            id: "Left Banner Design",
      },
      {
            title: "Middle Banner Design",
            id: "Middle Banner Design",
      },
      {
            title: "Bottom Banner Design",
            id: "Bottom Banner Design",
      },
      {
            title: "Side Offer Banner",
            id: "Side Offer Banner",
      },
      {
            title: "Middle Offer Banner",
            id: "Middle Offer Banner",
      },
];

const BannerEdit = () => {
      const { bannerId } = useParams();

      const [banner, setBanner] = useState([]);
      const [title, setTitle] = useState("");
      const [design, setDesign] = useState("");
      const [link, setLink] = useState("");
      const [image, setImage] = useState("");
      const [imageUrl, setImageUrl] = useState("");
      const [status, setStatus] = useState("");
      const [loading, setLoading] = useState(false);

      const loadData = async () => {
            await privateApi
                  .get(`/dashboard/banners/${bannerId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setBanner(response.data.banner);
                              setTitle(response.data.banner.title);
                              setDesign(response.data.banner.design);
                              setLink(response.data.banner.links);
                              setImageUrl(response.data.banner.image);
                              setStatus(response.data.banner.status);
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title ? title : banner.title,
                  link: link,
                  design: design,
                  status: status ? status : banner.status,
                  image: image,
            };

            await privateApi
                  .post(`/dashboard/banners/${bannerId}`, data)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleFormSubmit}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Edit Banner">
                                                <LinkButton
                                                      link="/dashboard/banners"
                                                      title="Back"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Title"
                                                            value={title}
                                                            required={true}
                                                            classes={8}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormSelect
                                                            title="Design"
                                                            options={designs}
                                                            selected={design}
                                                            setData={setDesign}
                                                            required={true}
                                                            classes={4}
                                                      />
                                                      <FormInput
                                                            title="Link"
                                                            value={link}
                                                            classes={4}
                                                            handleChange={
                                                                  setLink
                                                            }
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            selected={status}
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row>
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={true}
                                                            imageUrl={imageUrl}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Col lg={12}>
                                                      <FormButton
                                                            title="Submit"
                                                            loading={loading}
                                                      />
                                                </Col>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default BannerEdit;
